module.exports = __webpack_public_path__ + "static/media/logo_icon.c80c501f.svg";